import superagent from 'superagent'
import isNil from 'lodash/isNil'

export const circlesSet = circles => ({
  type: 'CIRCLES_SET',
  payload: circles
})

export const circleCreate = circle => ({
  type: 'CIRCLE_CREATE',
  payload: circle
})

export const circleUpdate = circle => ({
  type: 'CIRCLE_UPDATE',
  payload: circle
})

export const circleDelete = id => ({
  type: 'CIRCLE_DELETE',
  payload: id
})

export const circleFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/measurement/get?activityId=1&measurementType=5`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        if (!isNil(res.body)) {
          res.body.map(s => {
            if (s.photoId) {
              $.ajax({
                method: 'GET',
                url: `${__API_URI__}/photo/get/${s.photoId}`,
                headers: {
                  Authorization: `Bearer ${token}`,
                  Platform: 'Web',
                  Version: `${__version__}`
                }
              }).done(res => {
                s.photo = res
              })
            }
          })
        }
        resolve(res.body)
        dispatch(circlesSet(res.body))
      })
  })
}

export const circleCreateRequest = circleObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .post(`${__API_URI__}/measurement/create`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(circleObj))
      .end((err, res) => {
        if (err) {
          reject(err);
          if (err.status == 401) {
            return err.status;
          }
        }
        Countly.q.push([
          'add_event',
          {
            key: 'Create Circle',
            count: 1,
          },
        ]);

        if (res.body.photoId) {
          // Fetch photo details based on photoId
          $.ajax({
            method: 'GET',
            url: `${__API_URI__}/photo/get/${res.body.photoId}`,
            headers: {
              Authorization: `Bearer ${token}`,
              Platform: 'Web',
              Version: `${__version__}`,
            },
          })
            .done((photoRes) => {
              // Add the photo data to the main response body
              res.body.photo = photoRes;

              // Dispatch the circle creation with the updated payload
              dispatch(circleCreate(res.body));
              resolve(res.body);
            })
            .fail((ajaxErr) => {
              console.error('Error fetching photo details:', ajaxErr);
              reject(ajaxErr);
            });
        } else {
          // Directly dispatch if no photoId is present
          dispatch(circleCreate(res.body));
          resolve(res.body);
        }
      });

  })
}

export const circleUpdateRequest = circleObj => (dispatch, getState, token) => {
  return new Promise((resolve, reject) => {
    superagent
      .put(`${__API_URI__}/measurement/update`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .send(JSON.stringify(circleObj))
      .end((err, res) => {
        if (err) {
          reject(err)
          if (err.status == 401) {
            return err.status
          }
        }
        if (res.photoId) {
          $.ajax({
            method: 'GET',
            url: `${__API_URI__}/photo/get/${res.photoId}`,
            headers: {
              Authorization: `Bearer ${token}`,
              Platform: 'Web',
              Version: `${__version__}`
            }
          }).done(res => {
            res.photo = res
          })
        }
        dispatch(circleUpdate(res.body))
        resolve(res.body)
      })
  })
}

export const circleDeleteRequest = id => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .delete(`${__API_URI__}/measurement/delete/${id}`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          if (err.status == 401) {
            return err.status
          }
        }
        resolve(res.body)
        dispatch(circleDelete(id))
      })
  })
}
